import { BillingComment } from "src/types/billing-comment";
import * as mvteAPI from "src/api/mvte.api";
import { useEffect, useState } from "react";

export function BillingComments({
    customerCode,
    orderNumber,
}: {
    customerCode: string | null;
    orderNumber: string | null;
}) {
    const [billingComments, setBillingComments] = useState<BillingComment>();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (customerCode === null) return;

        setIsLoading(true);

        mvteAPI.fetchBillingComments({ customerCode }).then((data) => {
            setBillingComments(data);
            setIsLoading(false);
        });
    }, [customerCode]);

    if (!orderNumber) {
        return (
            <div className="bg-white rounded-sm p-3 h-full flex items-center justify-center text-gray-500">
                Select order number to view billing comments
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className="bg-white rounded-sm p-3 h-full flex items-center justify-center text-gray-500">
                <span>Loading billing comments...</span>
            </div>
        );
    }

    if (!billingComments) {
        return (
            <div className="bg-white rounded-sm p-3 h-full flex items-center justify-center text-gray-500">
                No comments found for order #{orderNumber}
            </div>
        );
    }

    return (
        <div className="bg-white rounded-sm overflow-y-auto h-full">
            <div className="px-3 py-3 flex justify-between items-center sticky top-0 bg-white border-b">
                <h2 className="text-gray-500 font-medium">Billing Comments</h2>
            </div>
            <div className="bg-white rounded-sm px-3 pb-3 max-w-3xl text-sm">
                <div>
                    <span>{billingComments.billingComments}</span>
                </div>
            </div>
        </div>
    );
}
